import { useEffect } from 'react';
import { Center, Heading } from '@chakra-ui/react';
import {
  Flex,
  Box,
  Image,
  Stack,
  useColorModeValue,
  Spinner,
  useToast
} from "@chakra-ui/react";
import { appRequest } from "routes";

export default function VerifyEmailForm(): JSX.Element {
  const toast = useToast();
  async function verifyEmail() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const input = {
        'token': token
      };
      const response: any = await appRequest("auth", "verifyEmail", input);
      if (response) {
        // const { token } = response;
        if (response.status === "error") {
          toast({
            title: response.message,
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top-right",
          });
          return;
        } else {
          toast({
            title: "Email Verifying successfully, please login",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top-right",
          })
          window.location.href = "/login";
        }
        // await localStorage.setItem("auth-token", token);
        // window.location.href = "/";
      }
    } catch (error: any) {
      toast({
        title: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-left",
      });
    }
  }

  useEffect(() => {
    verifyEmail()
  }, [])

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={2} w={"full"} maxW={"md"} p={6} py={12}>
        <Stack align={"center"}>
          <Image src="/img/sequelstring.webp" width={320} />
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Center>
            <Heading
              color="teal.300"
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="700"
              mb="11px"
            >
              Verifying your Email
            </Heading>
          </Center>
          <Center
            fontSize={{ base: "sm", sm: "md" }}
            color={useColorModeValue("gray.400", "gray.800")}
            fontWeight="700"
            mb={8}
          >
            Please wait while we verify your email
          </Center>
          <Center>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="teal.500"
              size="xl" />
          </Center>

          {/* <FormControl>
            <Center>
              <HStack>
                <PinInput>
                  <PinInputField />
                  <PinInputField />
                  <PinInputField />
                  <PinInputField />
                </PinInput>
              </HStack>
            </Center>
          </FormControl>
          <Stack spacing={6} mt={8}>
            <Button
              bg="teal.300"
              color="white"
              h={"45px"}
              fontWeight="700"
              _hover={{
                bg: "teal.400",
              }}
            >
              Verify
            </Button>
          </Stack> */}
        </Box>
      </Stack>
    </Flex>
  );
}